/* #28 · Fila de accesorios en el carro (30-sep-2026). < 4 KB, sin dependencias.
 * Hace tres cosas:
 *  1. Cohorte bb_acc_cohorte (mismas 5 reglas que bb-cohorte.liquid): ?bb_acc=a|b manda
 *     y se guarda; en vista previa siempre b; si hay guardada se respeta; si no, 50/50.
 *     Pone html.bb-acc-a|b ANTES de que el drawer pida el HTML del carro (este script va
 *     en el <head> con defer: corre antes de DOMContentLoaded, y el carro se pide después).
 *  2. Agrega con un toque: POST cart/add.js con _bb_rec y dispara `ajaxProduct:added`
 *     para que CartDrawer.buildCart() vuelva a pedir cart.ajax (la fila se recalcula y
 *     saca el tipo agregado). Estampa el atributo de carro bb_acc_cohorte.
 *  3. Mide: bb_acc_view_a|b (una vez por sesión de drawer abierto con la fila), bb_acc_add.
 */
(function () {
  var doc = document.documentElement;
  var preview = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function elegir() {
    var c = null;
    try {
      var q = /[?&]bb_acc=([ab])(?:&|$)/.exec(location.search);
      c = q ? q[1] : (preview ? 'b' : localStorage.getItem('bb_acc_cohorte'));
      if (c !== 'a' && c !== 'b') c = Math.random() < 0.5 ? 'a' : 'b';
      if (!preview || q) localStorage.setItem('bb_acc_cohorte', c);
    } catch (e) { c = preview ? 'b' : (Math.random() < 0.5 ? 'a' : 'b'); }
    return c;
  }
  var cohorte = elegir();
  doc.classList.add('bb-acc-' + cohorte);
  window.bbAccCohorte = cohorte;

  /* Registro para la compuerta: en vista previa no se manda nada a GA4 (como los otros
     módulos), pero queda anotado para poder verificarlo. */
  window.bbAccRegistro = window.bbAccRegistro || [];
  function track(nombre, params) {
    window.bbAccRegistro.push({ n: nombre, p: params || {}, t: Date.now() });
    if (preview) return;
    var privacy = window.Shopify && Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;
    try {
      if (typeof window.gtag === 'function') window.gtag('event', nombre, params || {});
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: nombre }, params || {}));
    } catch (e) {}
  }

  /* Vista: cada vez que el drawer se abre con la fila presente (en los dos brazos: en
     `a` la fila existe oculta, así el denominador es el mismo). Una vez por apertura. */
  var vistaEnviada = false;
  function revisarVista() {
    var drawer = document.getElementById('CartDrawer');
    var fila = drawer && drawer.querySelector('[data-bb-acc]');
    var abierto = drawer && drawer.classList.contains('drawer--is-open');
    if (!fila || !abierto) { if (!abierto) vistaEnviada = false; return; }
    if (vistaEnviada) return;
    vistaEnviada = true;
    var modo = fila.getAttribute('data-modo');
    var brazo = modo === 'todos_b' ? 'b' : cohorte;
    if (modo === 'todos_b') doc.classList.add('bb-acc-b');
    track('bb_acc_view_' + brazo, { tipo: fila.getAttribute('data-tipo'), kit: fila.getAttribute('data-kit'), n: fila.getAttribute('data-n') });
  }
  var obs = new MutationObserver(revisarVista);
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) obs.observe(drawer, { attributes: true, childList: true, subtree: true, attributeFilter: ['class'] });
  });

  /* Agregar con un toque (delegado: el HTML del carro se reemplaza en cada rebuild). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bb-acc-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var fila = btn.closest('[data-bb-acc]');
    var id = parseInt(btn.getAttribute('data-bb-acc-add'), 10);
    var handle = btn.getAttribute('data-handle');
    var pos = (btn.closest('[data-bb-acc-fila]') || {}).getAttribute ? btn.closest('[data-bb-acc-fila]').getAttribute('data-pos') : '';
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Agregando…';
    var cabeceras = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    fetch(raiz + 'cart/add.js', { method: 'POST', headers: cabeceras, body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _bb_rec: 'w:accesorios-carro' } }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          btn.disabled = false; btn.textContent = (res.json && res.json.description) ? 'Sin stock' : original;
          track('bb_acc_error', { handle: handle, code: res.json && res.json.status });
          return;
        }
        track('bb_acc_add', { handle: handle, pos: pos, tipo: fila ? fila.getAttribute('data-tipo') : '', kit: fila ? fila.getAttribute('data-kit') : '' });
        btn.textContent = 'Agregado ✓';
        var attrs = {}; attrs.bb_acc_cohorte = cohorte;
        fetch(raiz + 'cart/update.js', { method: 'POST', headers: cabeceras, body: JSON.stringify({ attributes: attrs }) })
          .catch(function () {})
          .then(function () {
            /* El theme escucha este evento en document: rebuild + open (ya está abierto). */
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: (res.json.items || [res.json])[0] } }));
          });
      })
      .catch(function () { btn.disabled = false; btn.textContent = original; });
  });
})();
